import {ReactElement} from 'react'
import {Grid} from '@material-ui/core'
import Loading from '../../../../../../Common/Loading'

export const LoadingLayout = (): ReactElement => (
  <Grid item xs={12}>
    <Loading />
  </Grid>
)
